export default __webpack_public_path__ + "static/media/ic_appointment.27e658c1.svg";